import { Directive, Input, HostListener, ElementRef, Renderer2, inject, output } from '@angular/core';

@Directive({ selector: '[appTableSort]' })
export class TableSortDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Input() sortColumn: string = '';
  readonly sortChange = output<any>();

  private sortOrder: 'asc' | 'desc' = 'asc';

  @HostListener('click') onClick() {
      if (this.sortColumn) {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
          this.sortChange.emit({sortColumn: this.sortColumn, sortOrder: this.sortOrder});
          this.updateArrowIndicators(this.sortColumn);
      }
  }

  private updateArrowIndicators(columnName: string) {
      const headers = this.el.nativeElement.parentElement.querySelectorAll('th');
      headers.forEach((header: HTMLElement) => {
          const indicator = header.querySelector(`#sort${columnName.replace(',',"")}`);
          if (indicator) {
              header.removeChild(indicator);
          }
      });

      const indicator = this.renderer.createElement('span');
      this.renderer.setAttribute(indicator, 'id', `sort${columnName.replace(',',"")}`);
      this.renderer.setStyle(indicator, 'margin-left', '0.5em');
      this.renderer.setProperty(indicator, 'innerHTML', this.sortOrder === 'asc' ? '&#9650;' : '&#9660;');
      this.renderer.appendChild(this.el.nativeElement, indicator);
  }
}
